Hop.defineModule('c-avatar-initials', (root, param) => {
    // color set used for multiple avatar initialisations
    const AI_COLOR_PATTERNS = ['#035266', '#12CFC9', '#FF5C57', '#FFC200', '#737370'];

    const DEFAULT_MAX_LETTERS = 2;
    const DEFAULT_COMPONENT_CLASS_NAME = 'm-avatar-picture';

    const MAX_LETTERS = param.maxLetters || DEFAULT_MAX_LETTERS;
    const COMPONENT_CLASS_NAME = param.componentClassName || DEFAULT_COMPONENT_CLASS_NAME;
    const AVATAR_ATTRIBUTE = 'data-avatar-fullname';

    function initAvatarInitial(el, avatarIdx, nameAndColorMap) {
        const completeName = el.getAttribute(AVATAR_ATTRIBUTE);
        const initials = getAvatarInitials(completeName);
        const color = getAvatarColor(nameAndColorMap, completeName, avatarIdx);

        setUpAvatar(el, initials, color);
    }

    function getAvatarInitials(completeName) {
        function getFirstLetter(string) {
            const cleanedString = string.replace(/[';,:()]/g, '');
            return cleanedString.charAt(0);
        }

        let arrayName = completeName.split(' ');
        arrayName = arrayName.slice(0, MAX_LETTERS);
        arrayName.forEach((str, idx) => {
            arrayName[idx] = getFirstLetter(str);
        });

        return arrayName.join('').toUpperCase();
    }

    function getAvatarColor(nameAndColorMap, completeName, avatarIdx) {
        const avatarWithSameName = nameAndColorMap.filter((el) => el.name === completeName)[0];

        if (avatarWithSameName !== undefined) {
            return avatarWithSameName.color;
        } else {
            nameAndColorMap.push({name: completeName, color: AI_COLOR_PATTERNS[avatarIdx]});
            return AI_COLOR_PATTERNS[avatarIdx];
        }
    }

    function setUpAvatar(el, initials, color) {
        const id = el.getAttribute('id');
        const newElement = document.createElement('div');

        if (id) {
            newElement.setAttribute('id', id);
        }

        newElement.classList.add(...el.classList, COMPONENT_CLASS_NAME);
        newElement.style.backgroundColor = color;
        newElement.innerHTML = initials;
        el.after(newElement);
        el.remove();
    }

    function initAvatarInitials(container) {
        const avatars = container.querySelectorAll(`[${AVATAR_ATTRIBUTE}]`);
        const NAME_AND_COLOR_MAP = [];
        avatars.forEach((avatar, idx) => {
            initAvatarInitial(avatar, idx, NAME_AND_COLOR_MAP);
        });
    }

    initAvatarInitials(root, param);

    return function destroy() {};
});
